import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import PrimaryButton from "../button/PrimaryButton";
import clsx from "clsx";

export const MidiDealCancelModal = ({
    open,
    onClose,
    onConfirm,
    savings
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (open) {
            setIsVisible(true);
            const timer = setTimeout(() => setIsAnimating(true), 10);
            return () => clearTimeout(timer);
        } else {
            setIsAnimating(false);
            const timer = setTimeout(() => {
                setIsVisible(false);
            }, 300);
            return () => clearTimeout(timer);
        }
    }, [open]);

    if (!isVisible) return null;

    const handleBackdropClick = (e) => {
        e.stopPropagation();
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const modalContent = (
        <div
            className={clsx(
                "fixed inset-0 z-[1999] flex items-center justify-center bg-black/80 transition-opacity duration-300",
                {
                    "opacity-100": isAnimating,
                    "opacity-0": !isAnimating
                }
            )}
            onClick={handleBackdropClick}
        >
            <div
                className={clsx(
                    "relative mx-4 w-full max-w-md rounded-3xl bg-white p-8 shadow-2xl transition-all duration-300",
                    {
                        "scale-100 opacity-100": isAnimating,
                        "scale-95 opacity-0": !isAnimating
                    }
                )}
            >
                <div className="relative mb-12 mt-8 flex justify-center">
                    <span
                        className="text-6xl h-12 text-white geomanistBold "
                        style={{
                            WebkitTextStroke: "1px #ef4444",
                            textShadow: "2px 2px 0px #ef4444, 2px 3px 0px #ef4444,2px -1px 0px #ef4444, 2px 4px 0px #ef4444, 2px 5px 0px #ef4444"
                        }}
                    >
                        {savings}
                    </span>
                    <div className="absolute left-1/2 top-1/2 h-1 w-2/3 rounded-full -translate-x-1/2 -translate-y-1/2 ring-2 ring-[#ffffffde] bg-red-500 shadow-[2px_3px_0_2px_#38373744]" />
                </div>

                <h2
                    className="mb-4 text-center text-2xl font-bold geomanistBold text-transparent bg-clip-text bg-gradient-to-tr from-orange-500 to-red-500"
                >
                    Tu vas perdre le deal...
                </h2>

                <p className="mb-6 geomanistMedium text-center text-lg text-gray-700">
                    Es-tu sûr de vouloir supprimer cet article ?
                </p>

                <PrimaryButton label="Confirmer" onClick={(e) => {
                    e.stopPropagation();
                    onConfirm(e);
                }} />

                <button
                    type="button"
                    onClick={(e) => {
                        e.stopPropagation();
                        onClose(e);
                    }}
                    className="w-full py-3 pt-8 text-2xl geomanistBold text-gray-600"
                >
                    Retour
                </button>
            </div>
        </div>
    );

    const targetNode = document.getElementById('modal-root') || document.body;
    return createPortal(modalContent, targetNode);
};
